// extracted by css-extract-rspack-plugin
export default {"emailPages__container":"emailPages__container__KFX2s","emailPages__content":"emailPages__content__VKp37"};